module.exports = __webpack_public_path__ + "media/images/pic/saska/polygon_news_bigger_bg-9ff2d5e94f8ea2406bfef010c0a73613.png";